import React, { useRef } from "react";
import { Modal } from "antd";
import styles from "./PagePreviewModal.module.scss";
import { sanitizeData } from '~/utils';
import { useFormState } from "react-final-form";
import { getMockBackendHtml } from './mockBackendHtml';
import { renderLogoPreview } from "../field-generate-logo/preview-logo";

interface PagePreviewModalProps {
  visible: boolean;
  onClose: () => void;
  logoSrc: string;
}

export const PagePreviewModal: React.FC<PagePreviewModalProps> = ({
  visible,
  onClose,
  logoSrc,
}) => {
  const previewRef = useRef<HTMLDivElement>(null);

  const { values } = useFormState();

  const payform_name = values?.payform_name;
  const product_name = values?.product_name;

  const htmlContent = getMockBackendHtml(product_name);

  return (
    <Modal
      title="Предпросмотр образца платёжной страницы"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <div className={styles.browserFrame}>
        <div className={styles.browserHeader}>
          <div className={styles.navButtons}>
            <span className={styles.button}></span>
            <span className={styles.button}></span>
            <span className={styles.button}></span>
          </div>

          <div className={styles.addressBar}>
            {payform_name ? <span>{`https://${payform_name}.payform.ru`}</span> : <span style={{ fontSize: 14, background: '#FEDFDF' }}>заполните поле "Ссылка на платёжную страницу"</span>}
          </div>
          <div className={styles.bookmarks}>
            <span>Закладки</span>
          </div>
        </div>

        <div className={styles.previewContainer}>
          <div className={styles.previewContainerLogo}>
            {renderLogoPreview(logoSrc)}
          </div>

          <div
            className={styles.previewContent}
            ref={previewRef}
            dangerouslySetInnerHTML={{
              __html: sanitizeData(htmlContent, {
                USE_PROFILES: { html: true },
              })
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
